<template>
<div id="app">
    <router-view />

    <van-tabbar route v-show="this.$route.meta.showTab" safe-area-inset-bottom>
        <van-tabbar-item replace to="/pool" icon="shop-collect-o" :badge="orderPoolCount && orderPoolCount > 0 ? orderPoolCount : ''">订单池</van-tabbar-item>
        <van-tabbar-item replace to="/wait-bid" icon="balance-list-o" :badge="bidOrderCount && bidOrderCount > 0 ? bidOrderCount : ''">竞价中</van-tabbar-item>
        <van-tabbar-item replace to="/wait" icon="todo-list-o" :badge="pendingConfirmCount && pendingConfirmCount > 0 ? pendingConfirmCount : ''">待处理</van-tabbar-item>
        <van-tabbar-item replace to="/rule" icon="setting-o">报价方案</van-tabbar-item>
        <van-tabbar-item replace to="/mine" icon="user-circle-o">工作台</van-tabbar-item>
    </van-tabbar>
    <div style="display:none ">
        <audio ref="audio2" :src="require('@/assets/tip.mp3')" :autoplay="false" />
    </div>
    <div style="display:none ">
        <audio ref="audio3" :src="require('@/assets/neworder.ff3a63f4.mp3')" :autoplay="false" />
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from 'vuex';
import Api from '@/api-service'
export default {
    data() {
        return {
            order_id : 0,
            bidOrderTimer: null,
            tipTimer: null,
            appVersion: '2.2.0'
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.tipTimer = setInterval(this.playTipMp2, 1000 * 10)
            // setInterval(this.playTipMp3, 1000 * 5)
            
            // 检查版本并强制刷新
            this.checkVersionAndRefresh();
        })
    },
    watch: {
        // 监听用户登录状态变化
        hasGetUserInfo(newVal) {
            if (newVal) {
                // 用户登录成功后，开始获取订单数量
                this.fetchBidOrderCount();
                this.bidOrderTimer = setInterval(this.fetchBidOrderCount, 10000);
            } else {
                // 用户未登录时，清除定时器
                if (this.bidOrderTimer) {
                    clearInterval(this.bidOrderTimer);
                    this.bidOrderTimer = null;
                }
                // 清空订单数量
                this.setOrderPoolCount(0);
                this.setBidOrderCount(0);
                this.setPendingConfirmCount(0);
            }
        }
    },
    beforeDestroy() {
        if (this.bidOrderTimer) {
            clearInterval(this.bidOrderTimer);
            this.bidOrderTimer = null;
        }
        if (this.tipTimer) {
            clearInterval(this.tipTimer);
            this.tipTimer = null;
        }
    },
    computed: {
        ...mapGetters(['hasGetUserInfo', 'orderPoolCount', 'bidOrderCount', 'pendingConfirmCount']),
        userInfo() {
            return this.$store.state.user.userInfo;
        },
    },
    methods: {
        ...mapMutations(['setOrderPoolCount', 'setBidOrderCount', 'setPendingConfirmCount']),
        playTipMp2() {
            if (!this.hasGetUserInfo) {
                // console.log('not login')
                return
            }
            Api.hasMyOrder({}).then(res => {
              console.log(res)
                if (res.has_new_order) {
                    this.$refs.audio2.play()
                }
            })
        },
        playTipMp3() {
            if (!this.hasGetUserInfo) {
                // console.log('not login')
                return
            }
            Api.hasNewOrder({order_id:this.order_id}).then(res => {
              console.log(res)
                if (res.has_new_order) {
                    this.order_id = res.order_id
                    this.$refs.audio3.play()
                }
            })
        },
        fetchBidOrderCount() {
            // 检查用户是否已登录
            if (!this.hasGetUserInfo) {
                console.log('用户未登录，跳过获取订单数量');
                return;
            }
            
            Api.getBidInfo({}).then(res => {
                this.setOrderPoolCount(res.available_order_count || 0);
                this.setBidOrderCount(res.bidding_count || 0);
                this.setPendingConfirmCount(res.pending_confirm_count || 0);
            }).catch(() => {
                this.setOrderPoolCount(0);
                this.setBidOrderCount(0);
                this.setPendingConfirmCount(0);
            })
        },
        // 添加更新红点数字的方法，供其他页面调用
        updateBidOrderCount(count) {
            this.setBidOrderCount(count);
        },
        updatePendingConfirmCount(count) {
            this.setPendingConfirmCount(count);
        },
        checkVersionAndRefresh() {
            // 检查是否在微信浏览器中
            const isWechat = /MicroMessenger/i.test(navigator.userAgent);
            if (isWechat) {
                // 从localStorage获取上次的版本号
                const lastVersion = localStorage.getItem('app_version');
                const currentVersion = this.appVersion;
                
                // 如果版本号不同，强制刷新
                if (lastVersion !== currentVersion) {
                    localStorage.setItem('app_version', currentVersion);
                    
                    // 添加时间戳参数强制刷新
                    const url = new URL(window.location.href);
                    const currentTime = new Date().getTime();
                    url.searchParams.set('_t', currentTime);
                    url.searchParams.set('_v', currentVersion);
                    
                    // 使用replace避免在历史记录中留下旧页面
                    window.location.replace(url.toString());
                }
            }
        }
    }
}
</script>

<style lang="scss">
@import './styles/index.scss';

html,
body,
#app {
    width: 100%;
    height: 100%;
    background-color: #f3f3f3;
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", "Microsoft YaHei", sans-serif !important;
    -webkit-font-smoothing: antialiased;
}

#app {
    display: flex;
    flex-direction: column;
}

/* tabbar 底部安全区，避免被 iPhone 刘海/Home 条遮挡 */
::v-deep .van-tabbar {
    padding-bottom: env(safe-area-inset-bottom, 0px);
}
</style>
